
export default  (ctx:HTMLElement, onZoomComplete: Function, onHover: Function, onClick: Function, afterDatasetsDraw: Function ) => {
  return {
    type: 'scatter',
    data: {datasets: []},
    options: {
      scales: {
        y: { beginAtZero: true,
             title: { display: true, text: 'Abfluss [m³/s]'}},
        x: { position: 'bottom',
             reverse: true,
             title: { display: true, text: 'Gewässer km'}}
      },
      plugins: {
        zoom: {
          pan: {enabled: true, 
                onPanComplete: onZoomComplete },
          zoom: { wheel: {enabled: true},
                  mode: 'xy',
                  onZoomComplete: onZoomComplete}
        },
        corsair: {color: 'rgb(51, 153, 255)', width: 2},
        legend: { labels: {
            filter: function(legendItem, data) {
              let label = data.datasets[legendItem.datasetIndex].label || '';
              if (typeof(label) !== 'undefined') {
                return label;
              }
              return false;
            }
          }
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              let label = '';
              if (context.parsed.x != null && context.parsed.x != undefined) {
                label = ' x: '+ context.parsed.x +'; ';
              }
              if (context.parsed.y != null && context.parsed.y != undefined) {
                label += 'y: ' + context.parsed.y;
              }
              return label;
            }
          }
        }
      },
      maintainAspectRatio: false,
      onHover: onHover,
      onClick: onClick,
    },
    plugins: [{
      id: 'corsair',
      afterInit: (chart) => {chart.corsair = {x: 0,y: 0}},
      afterEvent: (chart, evt) => {
        const {chartArea: {top,bottom,left,right}} = chart;
        const {event: {x,y}} = evt;
        if (x < left || x > right || y < top || y > bottom) {
          chart.corsair = {x,y,draw: false}
          chart.draw();
          return;
        }

        chart.corsair = {x,y,draw: true}
        chart.draw();
      },
      afterDatasetsDraw: afterDatasetsDraw
    }]
  }
}